import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import React from 'react'
import { IoIosArrowDown } from 'react-icons/io'

const CustomAccordian = ({ title, children }) => {
    return (
        <Accordion
            defaultExpanded
            disableGutters
            sx={{
                backgroundColor: "transparent",
                boxShadow: 0,
                color: "inherit",
                minHeight: 0,
                margin: 0,
                '&:before': { display: 'none' },
                '&.Mui-expanded': {
                    minHeight: 0,
                    margin: 0
                },
            }}
        >
            <AccordionSummary
                sx={{
                    padding: 0,
                    margin: 0,
                    fontWeight: 700,
                    minHeight: 0,
                    color: "inherit",
                    '&.Mui-expanded': {
                        minHeight: 0,
                        margin: 0
                    },
                    "& .MuiAccordionSummary-content": {
                        margin: '8px 0'
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: '8px 0'
                    },
                    "& .MuiAccordionSummary-expandIconWrapper": {
                        color: "inherit"
                    }
                }}
                expandIcon={<IoIosArrowDown size={14} />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                {title}
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
                <div className="root-dashboard-sidebar-my-plan-links">
                    {children}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

export default CustomAccordian
